import { render, staticRenderFns } from "./ownerinfo.vue?vue&type=template&id=91d2c848&scoped=true&"
import script from "./ownerinfo.vue?vue&type=script&lang=js&"
export * from "./ownerinfo.vue?vue&type=script&lang=js&"
import style0 from "./ownerinfo.vue?vue&type=style&index=0&id=91d2c848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d2c848",
  null
  
)

export default component.exports